<template>
    <footer class="h-[72px] px-3.5 flex justify-between items-center bg-shine font-freizeit">
        <selection-description
            v-if="!isPersonalizeStep"
            class="mr-2 text-sm leading-tight"
        />

        <p
            v-else
            class="mr-2 text-3xl leading-tight"
        >
            {{ $t('ALMOST_THERE') }}
        </p>

        <p
            v-if="bottlePrice"
            class="text-3xl"
        >
            ${{ bottlePrice }}
        </p>
    </footer>
</template>

<script>
    import * as constants from '../constants';
    import allStores from '../stores/all';

    import SelectionDescription from './SelectionDescription.vue';

    export default {
        mixins: [allStores],

        components: {
            SelectionDescription,
        },

        computed: {
            bottlePrice() {
                return this.customizerStore.statePrice?.toFixed(0);
            },

            isPersonalizeStep() {
                return this.appStore.currentStep === constants.STEP_PERSONALIZE;
            },
        },
    };
</script>
